<p-confirmdialog
	[baseZIndex]="10000"
	[draggable]="false"
	[styleClass]="
		'primary-background primary-border w-full max-w-lg mx-2 rounded-lg'
	"
>
	<ng-template
		#headless
		let-message
		let-onAccept="onAccept"
		let-onReject="onReject"
	>
		<div class="w-full !px-6 !py-4 flex flex-col items-center">
			<i class="pi pi-fw pi-question text !text-5xl mb-6"></i>

			<div class="flex flex-col items-center">
				<span class="title mb-1">{{ message.header }}</span>
				<p class="description">{{ message.message }}</p>
			</div>

			<div class="w-full flex justify-center gap-2 mt-8">
				<lib-button
					[label]="message.acceptLabel"
					[severity]="'primary'"
					(click)="onAccept($event)"
				></lib-button>

				<lib-button
					[label]="message.rejectLabel"
					[severity]="'danger'"
					(click)="onReject($event)"
				></lib-button>
			</div>
		</div>
	</ng-template>
</p-confirmdialog>
